import MuiRadio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core'

export const Radio = withStyles((theme) => ({
  root: {
    padding: 0,
  },
  colorSecondary: {
    color: '#fff',
    '&$checked': {
      color: '#fff',
    },
  },
  checked: {},
  disabled: {
    color: 'rgba(255, 255, 255, 0.6) !important',
  },
}))(MuiRadio)
